import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBooking, useSnack } from '../../../hooks';
import { KoobInputSelect } from '@koob/ui';
import { formatDate, parseDateOnly, yearsSince } from '@koob/dates';
import { TravelerKindEnum } from '@koob/enums';

export default function LoadFromTraveler({ loadTraveler, type, customerFile }) {
  const { t } = useTranslation('booking', { keyPrefix: 'form' });
  const { notify } = useSnack();
  const { guests, nationalities } = useBooking();

  const [travelerIndex, setTravelerIndex] = React.useState(null);

  const travelers = [
    ...(customerFile?.travelers || []).map(traveler => ({
      ...traveler,
      nationality: traveler.nationality
        ? nationalities?.find(
            nationality => nationality.value === traveler.nationality,
          )
        : undefined,
      birthdate: traveler.birthdate
        ? parseDateOnly(traveler.birthdate)
        : undefined,
      passportExpirationDate: traveler.passportExpirationDate
        ? parseDateOnly(traveler.passportExpirationDate)
        : undefined,
    })),
    ...(guests || []).map(guest => ({
      ...guest,
      birthdate: guest.birthdate ? parseDateOnly(guest.birthdate) : undefined,
      passportExpirationDate: guest.passportExpirationDate
        ? parseDateOnly(guest.passportExpirationDate)
        : undefined,
      nationality: guest.nationality
        ? nationalities?.find(
            nationality => nationality.value === guest.nationality,
          )
        : undefined,
    })),
  ].filter(traveler => !!traveler.firstName && !!traveler.lastName);

  const travelersEligible =
    type === TravelerKindEnum.ADULT
      ? travelers.filter(
          traveler =>
            traveler.birthdate && yearsSince(traveler.birthdate) >= 18,
        )
      : travelers.filter(
          traveler => traveler.birthdate && yearsSince(traveler.birthdate) < 18,
        );

  useEffect(() => {
    if (travelerIndex !== null && travelers[travelerIndex]) {
      loadTraveler(travelers[travelerIndex]);
      setTravelerIndex(null);
      notify(t('importFromTraveler.success'));
    }
  }, [travelerIndex]);

  return (
    ((travelers?.length > 0 ||
      (customerFile &&
        customerFile.travelers &&
        customerFile.customerFileId)) && (
      <>
        <div className="flex space-x-3">
          {travelersEligible.length === 0 && travelers.length > 0 && (
            <div className="bg-red-300 rounded-lg max-w-xs">
              <div className="px-3 py-2">
                <div className="text-xs">
                  {t('importFromTraveler.noEligible')}
                </div>
              </div>
            </div>
          )}

          <KoobInputSelect
            placeholder={t('importFromTraveler.placeholder')}
            options={
              travelers.map((traveler, index) => ({
                label: `${
                  traveler?.gender && traveler.gender.charAt(0).toUpperCase()
                } ${traveler?.firstName} ${traveler?.lastName} ${
                  !!traveler?.birthdate
                    ? `(${formatDate(traveler?.birthdate, 'DD/MM/YYYY')})`
                    : ''
                }`,
                value: index,
              })) || []
            }
            value={travelerIndex}
            onValueChange={value => setTravelerIndex(value)}
          />
        </div>
      </>
    )) ??
    null
  );
}
